.fa{z-index:50;}